import { connect } from "react-redux";
import lodashGet from 'lodash/get';
import { UserTypesEnum, UserTypesHelper } from '../../utils/userTypesHelper.js';
import { Grid, Stack, Typography } from "@mui/material";
import CustomIFrame from "../customIFrame";
import StringTranslate from "../../assets/i18n/stringLanguage";

/**
 * Onglet affichant un formulaire adapté ou bien l'indication que la fonctionnalité n'est pas accessible
 * @typedef {Object} AuthorizationTabProps
 * @property {string} url
 * @param {AuthorizationTabProps} props
 * @returns {JSX.Element}
 */
const AuthorizationTab = ({url, ...props}) => {
  const { userType } = props;

  if ((UserTypesHelper.hasType(userType, UserTypesEnum.COOP_TECHNICIAN)) || (UserTypesHelper.hasType(userType, UserTypesEnum.SUPER_ADMIN))) {
    return (
      <Stack justifyContent={'center'} alignItems={'center'} sx={{ height: '400px' }}>
        <Typography>{StringTranslate.noPermissionAccessForTC}</Typography>
      </Stack>
    )
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <CustomIFrame className="iframes_profil" url={url}/>
      </Grid>
    </Grid>
  )
}

const mapStateToProps = state => ({
  userType: lodashGet(state, 'clientUserData.userDatas.userType', UserTypesEnum.UNKNOWN),
});

export default connect(mapStateToProps)(AuthorizationTab);
